"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationTree = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var NavigationTree = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .rst__nodeContent {\n        right: 0;\n    }\n\n    .rst__rowToolbar,\n    .rst__rowLabel {\n        flex: 1;\n        display: flex;\n        align-items: center;\n    }\n\n    .rst__rowLabel {\n        justify-content: space-between;\n    }\n\n    .rst__rowToolbar {\n        justify-content: flex-end;\n    }\n\n    .rst__rowSubtitle {\n        font-size: 85%;\n        line-height: inherit;\n        font-weight: normal;\n        white-space: pre;\n    }\n\n    .rst__moveHandle {\n        min-width: 44px;\n    }\n"])));

exports.NavigationTree = NavigationTree;